import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useLandingSignup } from "@/pages/landing-signup-context";

type SignupLinkProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

/** Styled control that opens the dealer sign-up modal on the landing page. */
export function SignupLink({ className, children, type, ...props }: SignupLinkProps) {
  const openSignup = useLandingSignup();
  return (
    <button type={type ?? "button"} className={className} onClick={openSignup} {...props}>
      {children}
    </button>
  );
}
